import { Divider, InlineGrid, Text, TextField } from "@shopify/polaris";
import React from "react";

const CustomAttributes = ({ data, handleCustomAttributesChange, product }) => {
  let productColor = "";
  const metafieldEdges = product?.metafields?.edges || [];
  metafieldEdges.forEach((val) => {
    if (val.node.key == "color") {
      productColor = val.node.value;
    }
  });
  return (
    <>
      <InlineGrid columns={["oneThird", "twoThirds"]}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            rowGap: "15px",
            paddingLeft: "30px",
            paddingTop: "20px",
            paddingBottom: "20px",
            width: "25vw",
          }}
        >
          <Text variant="headingLg" fontWeight="semibold">
            Custom Attributes
          </Text>
          <Text as="p">
            You can define Custom Color, Size, Material, Pattern and COGS. It
            will not write back to Shopify but it will be submitted to connected
            channels. Also,these attributes will be considered only if a
            particular attribute is not defined in Shopify.
          </Text>
        </div>
        <div style={{ paddingTop: "10px", paddingBottom: "20px" }}>
          <InlineGrid columns={2}>
            <div
              style={{
                width: "20vw",
                display: "flex",
                flexDirection: "column",
                rowGap: "5px",
              }}
            >
              <TextField
                id="color"
                label="Color"
                value={data?.color ? data?.color : productColor}
                onChange={handleCustomAttributesChange}
                autoComplete="off"
              />
              <TextField
                id="material"
                label="Material"
                value={data?.material}
                onChange={handleCustomAttributesChange}
                autoComplete="off"
              />
              <TextField
                id="cogs"
                label="Cost of Goods Sold(COGS)"
                value={data?.cogs}
                onChange={handleCustomAttributesChange}
                autoComplete="off"
              />
            </div>
            <div
              style={{
                width: "20vw",
                display: "flex",
                flexDirection: "column",
                rowGap: "5px",
              }}
            >
              <TextField
                id="size"
                label="Size"
                value={data?.size}
                onChange={handleCustomAttributesChange}
                autoComplete="off"
              />
              <TextField
                id="pattern"
                label="Pattern"
                value={data?.pattern}
                onChange={handleCustomAttributesChange}
                autoComplete="off"
              />
            </div>
          </InlineGrid>
        </div>
      </InlineGrid>
      <Divider />
    </>
  );
};

export default CustomAttributes;
